import { useState } from "react";
import { submitMessage } from "../../context/ContactUs";
import { Icon } from "../home/components/Icon";
import { useSiteTranslation } from "../home/i18n";
import "./contact.css";

const EMPTY_FORM = { username: "", fullname: "", email: "", message: "" };

const FIELDS = [
  { name: "username", labelKey: "contact.username", type: "text", autoComplete: "username" },
  { name: "fullname", labelKey: "contact.fullname", type: "text", autoComplete: "name" },
  { name: "email", labelKey: "contact.emailAddress", type: "email", autoComplete: "email" },
];

/** Support copy beside the contact form, in the new design. */
export function ContactSection() {
  const { t } = useSiteTranslation();
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await submitMessage(formData);
      setFormData(EMPTY_FORM);
      setStatus("sent");
    } catch (err) {
      setError(t("contact.error"));
      setStatus("error");
    }
  };

  const sending = status === "sending";

  return (
    <section className="section contact" id="contact">
      <div className="wrap contact-grid">
        <div className="contact-copy" data-reveal>
          <p className="eyebrow">{t("contact.eyebrow")}</p>
          <h2>{t("contact.title")}</h2>
          <p className="contact-lead">{t("contact.lead")}</p>
          <ul className="contact-details">
            <li>
              <span>
                <Icon name="mail" />
              </span>
              <div>
                <small>{t("contact.email")}</small>
                <a href="mailto:support@mjmarry.com" dir="ltr">support@mjmarry.com</a>
              </div>
            </li>
            <li>
              <span>
                <Icon name="shield" />
              </span>
              <div>
                <small>{t("contact.safetyTitle")}</small>
                <p>{t("contact.safetyText")}</p>
              </div>
            </li>
          </ul>
        </div>

        <form className="contact-card" onSubmit={handleSubmit} data-reveal>
          {FIELDS.map(({ name, labelKey, type, autoComplete }) => (
            <label key={name} className="contact-field">
              <span>{t(labelKey)}</span>
              <input
                type={type}
                name={name}
                autoComplete={autoComplete}
                value={formData[name]}
                onChange={handleChange}
                disabled={sending}
                required
              />
            </label>
          ))}
          <label className="contact-field">
            <span>{t("contact.message")}</span>
            <textarea
              name="message"
              rows={6}
              value={formData.message}
              onChange={handleChange}
              disabled={sending}
              required
            />
          </label>

          {status === "sent" && (
            <p className="contact-status success" role="status">
              {t("contact.sent")}
            </p>
          )}
          {status === "error" && (
            <p className="contact-status error" role="alert">
              {error}
            </p>
          )}

          <button className="contact-submit" type="submit" disabled={sending}>
            {sending ? t("contact.sending") : t("contact.submit")} {!sending && <Icon name="arrow" />}
          </button>
        </form>
      </div>
    </section>
  );
}
